module.exports = __webpack_public_path__ + "img/1444542782.fb5b815e.jpg";